<rt-report-parameters
    [controlNames]="controlNames"
    (getReport)="onGetReportClick($event)"
    (cancelReport)="onCancelClick()"
>
</rt-report-parameters>
<div *ngIf="displayReport">
    <dx-data-grid
        bds-grid
        id="bdsReportGrid"
        [dataSource]="gridSource"
        height="80vh"
        minHeight="200px"
        [allowColumnResizing]="false"
        (onRowDblClick)="onRowDblClick($event)"
    >
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-filter-row [visible]="false"></dxo-filter-row>
        <dxo-header-filter [visible]="false"></dxo-header-filter>
        <dxi-column caption="Car ID">
            <dxi-column
                dataField="car_init"
                caption="Car Init."
                sortOrder="asc"
                [sortIndex]="0"
            ></dxi-column>
            <dxi-column
                dataField="car_no"
                caption="Car No."
                sortOrder="asc"
                [sortIndex]="1"
            ></dxi-column>
        </dxi-column>
        <dxi-column
            dataField="ship_date_time"
            dataType="date"
            [format]="{ type: 'shortDate' }"
            caption="Ship Date"
        ></dxi-column>
        <dxi-column
            dataField="trouble_start_datetime"
            dataType="date"
            [format]="{ type: 'shortDate' }"
            caption="Trouble Start"
        ></dxi-column>
        <dxi-column
            dataField="trouble_end_datetime"
            dataType="date"
            [format]="{ type: 'shortDate' }"
            caption="Trouble End"
        ></dxi-column>
        <dxi-column dataField="compute_0006" caption="Delay (Hrs)"></dxi-column>
        <dxi-column dataField="trouble_type" caption="Trouble Type"></dxi-column>
        <dxi-column dataField="le" caption="L/E"></dxi-column>
        <dxi-column dataField="road" caption="Road"></dxi-column>
        <dxi-column caption="Location">
            <dxi-column dataField="loc_city" caption="City"></dxi-column>
            <dxi-column dataField="loc_state" caption="State"></dxi-column>
        </dxi-column>
        <dxi-column dataField="priority_code" caption="Priority"></dxi-column>
        <dxi-column dataField="initiator" caption="Initiator"></dxi-column>
        <dxi-column dataField="trip_status" caption="Trip Status"></dxi-column>
        <dxi-column dataField="car_status" caption="Car Status"></dxi-column>
        <dxi-column dataField="fleet_id" caption="Fleet"></dxi-column>
        <dxi-column dataField="business_group" caption="Business Group"></dxi-column>
    </dx-data-grid>
</div>
